import { createSlice } from '@reduxjs/toolkit';
import { TSettingInitialState } from './types';
import {
  fetchInsightSettings,
  fetchOverviewSettings,
  fetchVrrSettings,
  updateInsightsSettings,
  updateOverviewSettings,
  updateVrrSettings
} from './settingAction';
import { fetchUserInformation, signin } from '../app/appActions';
import {
  prepareInsightsSettings,
  prepareNodeOverviewSettings,
  prepareOverviewSettings,
  prepareVrrSettings
} from './services';

export const initialState: TSettingInitialState = {
  vrr_preferences: {
    resource_id: undefined,
    current_brand_id: undefined,
    current_account_id: undefined,
    language: undefined,
    period: {
      from: undefined,
      to: undefined
    }
  },
  overview: {
    detailed_metrics: {
      resource_id: undefined,
      main_kpi: 'cpc',
      main_kpi_sort: 'ASC',
      displayed_dimensions: undefined,
      displayed_columns: undefined,
      pined_dimensions: undefined
    },
    global_metrics: {
      resource_id: undefined,
      metrics: undefined
    },
    chart_metrics: {
      resource_id: undefined
    }
  },
  insights: {
    resource_id: undefined,
    filters: {
      kpi: 'all',
      tag: 'all'
    },
    cards: undefined,
    current_tab: undefined
  }
};

export const settingSlice = createSlice({
  name: 'settings',
  initialState: { ...initialState },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchOverviewSettings.fulfilled,
      (state, { payload }: any) => {
        return {
          ...state,
          overview: {
            ...state.overview,
            ...prepareOverviewSettings(payload.data)
          }
        };
      }
    );
    builder.addCase(
      fetchInsightSettings.fulfilled,
      (state, { payload }: any) => {
        return {
          ...state,
          insights: {
            ...state.insights,
            ...prepareInsightsSettings(payload.data[0])
          }
        };
      }
    );
    builder.addCase(updateVrrSettings.fulfilled, (state, { payload }: any) => {
      return {
        ...state,
        vrr_preferences: {
          ...state.vrr_preferences,
          ...prepareVrrSettings(payload.data)
        }
      };
    });
    builder.addCase(
      updateOverviewSettings.fulfilled,
      (state, { payload }: any) => {
        return {
          ...state,
          overview: {
            ...state.overview,
            ...prepareNodeOverviewSettings(payload.data)
          }
        };
      }
    );
    builder.addCase(
      updateInsightsSettings.fulfilled,
      (state, { payload }: any) => {
        return {
          ...state,
          insights: {
            ...state.insights,
            ...prepareInsightsSettings(payload.data)
          }
        };
      }
    );
    builder.addCase(fetchUserInformation.fulfilled, (state, { payload }) => {
      return {
        ...state,
        vrr_preferences: {
          ...state.vrr_preferences,
          ...prepareVrrSettings(payload.vrr_preferences)
        }
      };
    });
    builder.addCase(fetchVrrSettings.fulfilled, (state, { payload }) => {
      return {
        ...state,
        vrr_preferences: {
          ...state.vrr_preferences,
          ...prepareVrrSettings(payload.vrr_preferences)
        }
      };
    });
    builder.addCase(signin.fulfilled, (state, { payload }: any) => {
      return {
        ...state,
        vrr_preferences: {
          ...state.vrr_preferences,
          ...prepareVrrSettings(payload.vrr_preferences)
        }
      };
    });
  }
});

export default settingSlice.reducer;
